import { FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

interface CoverageStatusCardProps {
  messages: string[];
}

export const CoverageStatusCard: React.FC<CoverageStatusCardProps> = ({
  messages,
}) => {
  const messageRow: RowConfig[] = [
    {
      icon: 'warning',
      fields: [
        {
          type: 'list',
          label: strings.PathologyWarningCardLabel,
          display: messages,
        },
      ],
    },
  ];

  return (
    <FormCard
      cardColor="status-warning"
      showIcons={true}
      title={strings.LabelStatus}
      rows={messageRow}
    />
  );
};
